import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * 運び先アイコン
 */
const BuildingIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.675"
        height="14.108"
        viewBox="0 0 15.675 14.108"
      >
        <path
          d="M9.837,6.135V3H2V17.108H17.675V6.135Zm-4.7,9.4H3.568V13.972H5.135Zm0-3.135H3.568V10.837H5.135Zm0-3.135H3.568V7.7H5.135Zm0-3.135H3.568V4.567H5.135Zm3.135,9.4H6.7V13.972H8.27Zm0-3.135H6.7V10.837H8.27Zm0-3.135H6.7V7.7H8.27Zm0-3.135H6.7V4.567H8.27Zm7.837,9.4H9.837V13.972H11.4V12.4H9.837V10.837H11.4V9.27H9.837V7.7h6.27ZM14.54,9.27H12.972v1.568H14.54Zm0,3.135H12.972v1.567H14.54Z"
          transform="translate(-2 -3)"
        />
      </svg>
    </Icon>
  )
}

export default BuildingIcon
